export default __webpack_public_path__ + "img/d009145e40bd494f96d910a96370a7c3.png";